import React from "react";
import { Helmet } from "react-helmet-async";
import defaultSocialImage from "../../../images/home_background.png";

const SITE_URL = "https://webridge.co.za";

const toAbsoluteUrl = (value) => {
  if (!value || value.startsWith("data:")) {
    return new URL(defaultSocialImage, SITE_URL).href;
  }

  return new URL(value, SITE_URL).href;
};

const DynamicPage = ({
  title,
  description,
  canonicalPath,
  image,
  imageAlt,
  type = "website",
  robots = "index, follow",
  author,
}) => {
  const canonicalUrl = new URL(canonicalPath || "/", SITE_URL).href;
  const socialImage = toAbsoluteUrl(image);

  return (
    <Helmet htmlAttributes={{ lang: "en-ZA" }}>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      {author && <meta name="author" content={author} />}

      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:locale" content="en_ZA" />
      <meta property="og:site_name" content="WeBridge" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={socialImage} />
      <meta property="og:image:alt" content={imageAlt || title} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={socialImage} />
    </Helmet>
  );
};

export default DynamicPage;
